import { Mail, MapPin } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { CONTACT_EMAIL } from "../data/site";
import { PageHero, Reveal } from "../components/Reveal";
import { ContactForm } from "../components/ContactForm";

const Contato = () => {
  const { t } = useLanguage();
  const p = t.contact;

  return (
    <main data-testid="contact-page">
      <PageHero chip={p.chip} title={p.title} sub={p.sub} testid="contact-hero" />

      <section className="px-6 lg:px-12 py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 space-y-4">
            <Reveal>
              <div data-testid="contact-info-email" className="p-5 rounded-lg border border-ops bg-ops-core/10">
                <span className="mono-tag text-ops-light text-[10px] uppercase tracking-widest block mb-1.5">
                  {p.infoEmailTag}
                </span>
                <a
                  href={`mailto:${CONTACT_EMAIL}`}
                  data-testid="contact-email-link"
                  className="flex items-center gap-2.5 text-white font-display font-semibold hover:text-ops-light transition-colors"
                >
                  <Mail size={16} className="text-ops-light shrink-0" />
                  {CONTACT_EMAIL}
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.08}>
              <div data-testid="contact-info-terminal" className="p-5 rounded-lg border border-ops bg-ops-core/10">
                <span className="mono-tag text-ops-light text-[10px] uppercase tracking-widest block mb-1.5">
                  {p.infoAddr1Tag}
                </span>
                <div className="flex items-start gap-2.5 text-white text-sm">
                  <MapPin size={16} className="text-ops-light shrink-0 mt-0.5" />
                  {p.infoAddr1}
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.16}>
              <div data-testid="contact-info-office" className="p-5 rounded-lg border border-ops bg-ops-core/10">
                <span className="mono-tag text-ops-light text-[10px] uppercase tracking-widest block mb-1.5">
                  {p.infoAddr2Tag}
                </span>
                <div className="flex items-start gap-2.5 text-white text-sm">
                  <MapPin size={16} className="text-ops-light shrink-0 mt-0.5" />
                  {p.infoAddr2}
                </div>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="lg:col-span-7">
            <ContactForm />
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Contato;
